import axios from "axios";
import Swal from "sweetalert2";
import router from "@/router"; // sesuaikan path router kamu jika berbeda

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }

  return null;
}

// Global axios config
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

// Untuk Axios versi baru
axios.defaults.withXSRFToken = true;

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    const method = config.method?.toLowerCase();

    if (!config.headers) {
      config.headers = {};
    }

    /**
     * Kirim URL frontend aktif ke backend.
     */
    config.headers["X-Frontend-Url"] = window.location.href;

    /**
     * Karena JWT sekarang pindah ke HttpOnly cookie,
     * jangan lagi kirim Authorization dari localStorage.
     */
    // if (config.headers.Authorization) {
    //   delete config.headers.Authorization;
    // }

    // if (config.headers.common?.Authorization) {
    //   delete config.headers.common.Authorization;
    // }

    /**
     * Tambahkan CSRF token manual untuk request mutasi.
     */
    if (["post", "put", "patch", "delete"].includes(method)) {
      const xsrfToken = getCookie("XSRF-TOKEN");

      if (xsrfToken) {
        config.headers["X-XSRF-TOKEN"] = xsrfToken;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

import { clearClientSession } from "@/helpers/sessionHelper";

// Flag untuk mencegah popup sesi habis bertumpuk atau looping
let isShowingSessionExpiredAlert = false;

// Response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const url = String(error.config?.url || "").toLowerCase();

    // Abaikan jika error berasal dari endpoint autentikasi dasar
    const isAuthEndpoint =
      url.includes("auth/logout") ||
      url.includes("auth/logout-sso") ||
      url.includes("auth/login") ||
      url.includes("auth/login-pegawai") ||
      url.includes("auth/check-token") ||
      url.includes("referensi/konfig-login");

    // HANYA status 401 (Unauthorized) yang menandakan sesi token habis.
    // Status 403 (Forbidden) adalah masalah izin akses resource, BUKAN sesi habis.
    // Status 419 (CSRF mismatch) adalah masalah token CSRF form, BUKAN sesi habis.
    // Jangan pernah menghapus localStorage session pada 403 atau 419!
    if (status === 401 && !isAuthEndpoint) {
      const currentPath = (window.location.pathname || "").toLowerCase();
      const currentHref = (window.location.href || "").toLowerCase();
      const currentRoutePath = (router.currentRoute?.value?.path || "").toLowerCase();

      const isLoginOrLogoutPage =
        currentPath.includes("/login") ||
        currentPath.includes("/logout") ||
        currentHref.includes("/login") ||
        currentHref.includes("/logout") ||
        currentRoutePath.includes("/login") ||
        currentRoutePath.includes("/logout");

      // Jika user sudah berada di halaman login atau logout, jangan lakukan popup/redirect
      if (isLoginOrLogoutPage) {
        return Promise.reject(error);
      }

      // Deteksi apakah user adalah pegawai internal
      const isPegawai =
        localStorage.getItem("user_pegawai") === "pegawai_internal" ||
        currentPath.includes("pegawai") ||
        currentHref.includes("pegawai") ||
        currentRoutePath.includes("pegawai");
      const targetLoginRoute = isPegawai ? "/login-pegawai" : "/login";

      // Pastikan hanya satu alert sesi habis yang aktif
      if (!isShowingSessionExpiredAlert && !Swal.isVisible()) {
        isShowingSessionExpiredAlert = true;

        clearClientSession();

        Swal.fire({
          icon: "error",
          title: "Sesi habis",
          text: "Sesi Anda telah berakhir. Silakan masuk kembali.",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          isShowingSessionExpiredAlert = false;
          clearClientSession();

          if (!window.location.pathname.toLowerCase().includes("/login")) {
            router.push(targetLoginRoute).catch(() => {});
          }
        });
      }
    }

    return Promise.reject(error);
  },
);

export default axios;

